import React from 'react';
import { Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Warning } from '@material-ui/icons';

const POSITION = { vertical: 'bottom', horizontal: 'center' };

const Flash = ({ message, open, onClose, type }) => (
    <Snackbar anchorOrigin={POSITION} open={open} onClose={onClose}>
        <div className={`ckp-flash is-${type}`}>
            <span className="ckp-flash-icon">{type === 'error' ? <Warning /> : <CheckCircleIcon />}</span>
            <span className="ckp-flash-text">{message}</span>
            <span className="ckp-flash-icon">
                <IconButton className="ckp-flash-close" onClick={onClose} color="inherit">
                    <CloseIcon />
                </IconButton>
            </span>
        </div>
    </Snackbar>
);

export default Flash;
